import { useConfigStore } from "~/stores/extensionApi";

export default async function ({ store }) {
  const configStore = useConfigStore(store);

  if (!configStore.configs || Object.keys(configStore.configs).length === 0) {
    await configStore.loadConfigs();
  }

  if (!configStore.configsMobile || Object.keys(configStore.configsMobile).length === 0) {
    await configStore.loadConfigsMobile();
  }
}